import * as React from 'react';
import { BreadcrumbValue, BreadcrumbItem } from './breadcrumb-item';

export interface BreadcrumbProps {
  items: BreadcrumbValue[];
  onClickItem: (item: BreadcrumbValue) => void;
  home?: boolean;
  homeLabel?: string;
  onClickBreadcrumbHome?: () => void;
}

interface RenderBreadcrumbProps {
  item?: BreadcrumbValue;
  index?: number;
}

export class Breadcrumb extends React.Component<BreadcrumbProps, any> {

  private renderItem = ({ item, index }: RenderBreadcrumbProps) => {
    return <BreadcrumbItem
      key={item.value}
      item={item}
      onClickItem={this.props.onClickItem}
      last={index + 1 === this.props.items.length} />;
  };

  private renderHome = () => {
    return <BreadcrumbItem
      home={this.props.home}
      key={'home'}
      homeLabel={this.props.homeLabel}
      item={undefined}
      onClickItem={this.props.onClickBreadcrumbHome}
      last={this.props.items.length === 0} />;
  };

  public render() {
    const { items, home } = this.props;
    return (<ol className="breadcrumb">
      {home ? this.renderHome() : null}
      {items?.map((item, index) => this.renderItem({ item, index }))}
    </ol>);
  }
}
